import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";
import { toAbsoluteUrl } from "../../../_metronic";
import BetterCircularProgress from "../../components/BetterCircularProgress";
import CodePassword from "../../components/password/CodePassword";
import InsertEmail from "../../components/password/InsertEmail";
import { forgotPassword, resetPassword, validarCodigo } from "../../crud/auth.crud";
import NewPassword from "../../components/password/NewPassword";

class ForgotPassword extends Component {
	constructor () {
		super();

		this.state = {
			email: "",
			loading: false,
			submitted: false,
			step: 1
		};
	}

	onSubmit = () => {
		if (!this.state.email) {
			Swal.fire("Ops!", "O e-mail é uma informação obrigatória.", "error");
			return;
		} else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(this.state.email)) {
			Swal.fire("Ops!", "Você precisa informar um e-mail válido.", "error");
			return;
		}

		this.setState({ submitted: true });

		forgotPassword({ email: this.state.email })
			.then(async (res) => {
				window.scrollTo(0, 0);

				if (res.data.error) {

					Swal.fire("Ops!", res.data.error, "error");
				} else {
					await Swal.fire({
						icon: "success",
						title: "Tudo certo!",
						text: "Foi enviado um e-mail para redefinição de senha.",
						showConfirmButton: false,
						timer: 1500,
					});

					this.setState({ step: 2 });
				}
			})
			.catch((e) => {
				Swal.fire("Ops!", e.response?.data?.errors?.length > 0 ? e.response?.data?.errors[0] : "Parece que houve um problema ao enviar o e-mail. Por favor, entre em contato com o suporte.", "error");
			}).finally(() => this.setState({ submitted: false }));
	};

	submitCodigo = (value) => {
		this.setState({ submitted: true });

		validarCodigo({ pas_code: value }).then((res) => {
			this.setState({
				submitted: false,
				step: 3
			});
		}).catch((e) => {
			Swal.fire("Ops!", e.response?.data?.errors?.length > 0 ? e.response?.data?.errors[0] : "Código incorreto. Confira o código enviado para seu e-mail e tente novamente.", "error");
		}).finally(() => {
			this.setState({ submitted: false });
		})
	}

	submitNovaSenha = (value) => {
		this.setState({ submitted: true });

		resetPassword({
			adm_email: this.state.email,
			password: value
		}).then(async (res) => {
			await Swal.fire({
				icon: "success",
				title: "Tudo certo!",
				text: "Sua senha foi redefinida!",
				showConfirmButton: false,
				timer: 1500,
			});

			window.location.href = '/auth/login'
		}).finally(() => {
			this.setState({ submitted: false });
		})
	}

	render() {
		const { step, errors, loading, submitted } = this.state;
		return (
			<div style={{ margin: "50px 0px 50px 0px" }}>
				<div className="row" style={{ margin: "0" }}>
					<div className="col-lg-4 offset-lg-4">
						<div className="row">
							<div className="col-sm-12">
								<center>
									<img alt="Logo" src={toAbsoluteUrl("/images/logo.svg")} style={{ width: "200px", height: "auto", marginTop: "35px", marginBottom: "35px" }} />

									{step === 1 && <p style={{ padding: "10px 50px 15px 50px", fontSize: "18px", color: "#424242", fontWeight: "500" }}>Para recuperar seu acesso, por favor informe um e-mail.</p>}
									{step === 2 && <p style={{ padding: "10px 50px 15px 50px", fontSize: "18px", color: "#424242", fontWeight: "500" }}>Digite o código de recuperação.</p>}
									{step === 3 && <p style={{ padding: "10px 50px 15px 50px", fontSize: "18px", color: "#424242", fontWeight: "500" }}>Insira sua nova senha.</p>}

								</center>
							</div>

							<div className="col-sm-12">
								<BetterCircularProgress loading={loading}>
									{step === 1 && <InsertEmail errors={errors} submitted={submitted} handleChange={(e) => this.setState({ email: e.target.value })} handleSubmit={this.onSubmit} />}
									{step === 2 && <CodePassword voltar={() => this.setState({ step: 1, email: '' })} errors={errors} submitted={submitted} handleSubmit={this.submitCodigo} />}
									{step === 3 && <NewPassword errors={errors} submitted={submitted} handleSubmit={this.submitNovaSenha} />}

								</BetterCircularProgress>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(connect(null, null)(ForgotPassword));